module.exports = __webpack_public_path__ + "static/media/menuDinner.5e94f1ab.png";